<template>
  <div class="index">
    <swiper
      v-if="swiper.length > 0"
      :list="swiper"
      :height="400"
    />

    <div class="container" :style="{ marginTop: `${ swiper.length > 0 ? -36 : 10 }px` }">
      <div ref="navi" class="fixed-navi-wrapper">
        <navigator
          class="section"
          :class="{ 'navigator-fixed': naviFixed }"
        />
      </div>
      <el-row
        class="content"
        :gutter="20"
      >
        <el-col
          class="content-left"
          :lg="17"
          :md="24"
        >
          <div class="section">
            <panel title="招标公告" icon="assets/images/icon-bid-notice.png">
              <span
                slot="right"
                class="more"
                @click="$router.push({ path: '/bid/notice' })"
              >更多 ></span>

              <template v-if="notice.length > 0">
                <bid-item
                  v-for="(item, index) in notice"
                  :key="index"
                  :content-length="126"
                  :value="item"
                />
              </template>

              <empty-layout v-else />
            </panel>
          </div>
          <div class="section">
            <panel title="中标公告" icon="assets/images/icon-bid-win.png">
              <span
                slot="right"
                class="more"
                @click="$router.push({ path: '/bid/win' })"
              >更多 ></span>

              <template v-if="win.length > 0">
                <bid-item
                  v-for="(item, index) in win"
                  :key="index"
                  :content-length="126"
                  :value="item"
                />
              </template>

              <empty-layout v-else />
            </panel>
          </div>
        </el-col>
        <el-col class="content-right" :lg="7" :md="24">
          <div class="section">
            <panel title="最新资讯" icon="assets/images/icon-news.png">
              <span
                slot="right"
                class="more"
                @click="$router.push({ name: 'newsList' })"
              >更多 ></span>

              <template v-if="news.length > 0">
                <div
                  v-for="(item, index) in news"
                  :key="index"
                  class="news"
                  @click="$router.push({ name: 'newsDetail', query: { id: item.id }})"
                >
                  <img class="news-image" :src="item.picUrl">
                  <div class="news-container">
                    <div class="news-title ellipsis--l1">{{ item.title }}</div>
                    <div class="news-content ellipsis--l2">{{ item.text }}</div>
                    <div class="news-time">{{ item.createTime }}</div>
                  </div>
                </div>
              </template>

              <empty-layout v-else />
            </panel>
          </div>
          <div class="section">
            <panel title="模板下载" icon="assets/images/icon-template.png">
              <span
                slot="right"
                class="more"
                @click="$router.push({ path: '/download' })"
              >更多 ></span>

              <template v-if="templates.length > 0">
                <bids-download
                  v-for="(item, index) in templates"
                  :key="index"
                  :value="item"
                />
              </template>

              <empty-layout v-else />
            </panel>
          </div>
          <div class="section">
            <panel title="招标预告" icon="assets/images/icon-bid-preview.png">
              <span
                slot="right"
                class="more"
                @click="$router.push({ path: '/bid/preview' })"
              >更多 ></span>

              <template v-if="preview.length > 0">
                <bid-item
                  v-for="(item, index) in preview"
                  :key="index"
                  class="release-project"
                  is-preview
                  :content-length="33"
                  :value="item"
                  :show-detail-btn="false"
                />
              </template>

              <empty-layout v-else />
            </panel>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import Navigator from '@/components/Navigator'
import Panel from '@/components/Panel'
import BidsDownload from '@/components/BidsDownload'
import BidItem from '@/components/BidItem'
import EmptyLayout from '@/components/EmptyLayout'
import Swiper from '@/components/Swiper'

import { fetchIndexBanner, fetchTemplate, fetchNews, fetchNotice, fetchWin, fetchPreview } from '@/api'

const PROJECT_API_PARAMS = {
  pageSize: 5,
  pageNo: 1
}

export default {

  components: {
    Navigator,
    Panel,
    BidsDownload,
    BidItem,
    EmptyLayout,
    Swiper
  },
  data() {
    return {
      swiper: [],

      naviFixed: false,

      /* 招标公告 */
      notice: [],

      /* 中标公告 */
      win: [],

      /* 最新资讯 */
      news: [],

      /* 模板下载 */
      templates: [],

      /* 投标预告 */
      preview: [],

      searchKey: ''
    }
  },

  created() {
    this.fetchBanner()
    this.fetchNotice()
    this.fetchWin()
    this.fetchNews()
    this.fetchTemplate()
    this.fetchPreview()

    window.addEventListener('scroll', this.listenNavigatorFixed)
  },

  destroyed() {
    window.removeEventListener('scroll', this.listenNavigatorFixed)
  },

  methods: {
    /*
     * 获取banner
    */
    fetchBanner() {
      fetchIndexBanner()
        .then(res => {
          this.swiper = res.data
        })
    },

    /*
     * 获取招标公告
    */
    fetchNotice() {
      fetchNotice(PROJECT_API_PARAMS)
        .then(res => {
          this.notice = res.data.records
        })
    },

    /*
     * 获取中标公告
    */
    fetchWin() {
      fetchWin(PROJECT_API_PARAMS)
        .then(res => {
          this.win = res.data.records
        })
    },

    /*
     * 获取最新资讯
    */
    fetchNews() {
      fetchNews({
        pageSize: 3,
        pageNo: 1
      })
        .then(res => {
          this.news = res.data.records
        })
    },

    /*
     * 获取模板下载
    */
    fetchTemplate() {
      fetchTemplate({
        pageSize: 10,
        pageNo: 1
      })
        .then(res => {
          this.templates = res.data.records
        })
    },

    /*
     * 获取招标预告
    */
    fetchPreview() {
      fetchPreview({
        pageSize: 3,
        pageNo: 1
      })
        .then(res => {
          this.preview = res.data.records
        })
    },

    /*
     * 监听导航栏浮动
    */
    listenNavigatorFixed() {
      const { top } = this.$refs.navi.getBoundingClientRect()

      if (top <= 0) {
        if (!this.naviFixed) {
          this.naviFixed = true
        }
      } else {
        if (this.naviFixed) {
          this.naviFixed = false
        }
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.index {
  .swiper-container {
    /deep/ .swiper-pagination {
      bottom: 54px;
    }
  }
  .container {
    position: relative;
    z-index: 2;
    max-width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    .section {
      background-color: #fff;
      border-radius: 4px;
      + .section {
        margin: 20px 0 0;
      }
    }
    .fixed-navi-wrapper {
      height: 68px;
    }
    .navigator-fixed {
      position: fixed;
      top: 0;
      z-index: 99;
      max-width: 1200px;
      width: 100%;
    }
    /deep/ .navigator {
      height: 68px;
      .navigator-list {
        .navigator-item {
          &:first-child {
            margin-left: 30px;
          }
          &:nth-child(n + 2) {
            position: relative;
            margin: 0 0 0 51px;
            &::before {
              content: '';
              position: absolute;
              top: 50%;
              left: -25px;
              width: 1px;
              height: 14px;
              background-color: #E6E6E6;
              transform: translateY(-50%);
              pointer-events: none;
            }
          }
        }
      }
      .search {
        flex: 1 1 395px;
        max-width: 395px;
        margin: 0 5%;
      }
    }
    .content {
      padding: 10px 0 60px;
      .more {
        color: #666;
        cursor: pointer;
      }
      .content-left {
        margin: 0 0 20px;
        /deep/ .panel {
          padding: 0 30px 25px;
          .panel-header {
            &::after {
              left: -30px;
              right: -30px;
            }
          }
        }
        .bid-item {
          &:last-child {
            border-bottom: 0;
          }
        }
      }
      .content-right {
        /deep/ .panel {
          padding: 0 20px 15px;
          .panel-header {
            &::after {
              left: -20px;
              right: -20px;
            }
          }
        }
        .news {
          display: flex;
          padding: 15px 0;
          &:nth-child(n + 2) {
            border-top: 1px solid #F0F0F0;
          }
          .news-image {
            flex-shrink: 0;
            width: 123px;
            height: 96px;
            border-radius: 6px;
            margin: 0 14px 0 0;
            cursor: pointer;
          }
          .news-container {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .news-title {
              font-weight: bold;
              cursor: pointer;
            }
            .news-content {
              flex: 1;
              font-size: 12px;
              line-height: 20px;
              color: #808080;
              cursor: pointer;
              margin: 12px 0 0;
            }
            .news-time {
              font-size: 12px;
              color: #666;
              line-height: 15px;
              padding: 0 0 0 21px;
              background-image: url('~@/assets/images/icon-clock.png');
              background-repeat: no-repeat;
              background-position: 0 0;
              margin: 12px 0 0;
            }
          }
        }
        /deep/ .bids-download {
          margin: 24px 0 0;
          &:first-child {
            margin: 15px 0 0;
          }
          .download-title {
            max-width: 183px;
          }
        }
        /deep/ .release-project {
          .state-tag {
            display: none;
          }
          .bid-item-title {
            max-width: 242px;
          }
          .bid-item-container {
            text-indent: 0;
          }
          .bid-item-time {
            font-size: 12px;
            padding: 0;
            background-image: none;
          }
        }
      }
    }
  }
}
</style>
